module.exports = __webpack_public_path__ + "assets/img/dom-manipulation-comparison.efd4f65d.jpg";